import { isNumber, omit } from 'lodash-es';

import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import type {
  IAdminSettingsPaymentCountryGroupItemResponse,
  IAdminSettingsPaymentCountryGroupItemSavePayload,
} from '../types';
import {
  SETTINGS_PAYMENT_COUNTRY_GROUPS_CREATE_URL,
  SETTINGS_PAYMENT_COUNTRY_GROUPS_LIST_QUERY_KEY,
  SETTINGS_PAYMENT_COUNTRY_GROUPS_SAVE_MUTATION_KEY,
  SETTINGS_PAYMENT_COUNTRY_GROUPS_UPDATE_URL,

} from '../constants';

export default function useSettingsPaymentCountryGroupSaveMutation(): IContextMutationResult<
  IAdminSettingsPaymentCountryGroupItemResponse,
  Error,
  IAdminSettingsPaymentCountryGroupItemSavePayload
> {
  const { fetchPost, fetchPut } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<
    IAdminSettingsPaymentCountryGroupItemResponse,
    Error,
    IAdminSettingsPaymentCountryGroupItemSavePayload
  >({
    mutationKey: [SETTINGS_PAYMENT_COUNTRY_GROUPS_SAVE_MUTATION_KEY],
    mutationFn: (payload) => {
      if (isNumber(payload.id)) {
        return fetchPut<IAdminSettingsPaymentCountryGroupItemResponse>(
          SETTINGS_PAYMENT_COUNTRY_GROUPS_UPDATE_URL,
          omit(payload, 'id'),
          {
            urlParams: {
              id: payload.id,
            },
          },
        );
      }
      return fetchPost<IAdminSettingsPaymentCountryGroupItemResponse>(
        SETTINGS_PAYMENT_COUNTRY_GROUPS_CREATE_URL,
        omit(payload, 'id'),
        {
        },
      );
    },
    async onSuccess({ queryClient, variables }) {
      await queryClient.invalidateQueries({ queryKey: [SETTINGS_PAYMENT_COUNTRY_GROUPS_LIST_QUERY_KEY] });

      if (variables.id) {
        displayPresetToast('edited');
      } else {
        displayPresetToast('created');
      }
    },
  });
}
